"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRelatedGroups = exports.getGroups = exports.setRelatedStates = exports.getContentVersionLogs = exports.setRelatedContents = exports.getContents = exports.setRelatedUsers = exports.getUsers = void 0;
const tslib_1 = require("tslib");
const flatten_1 = tslib_1.__importDefault(require("lodash/flatten"));
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const set_1 = tslib_1.__importDefault(require("lodash/set"));
const uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
const ElasticsearchEnums_1 = require("../../__types/__enums/ElasticsearchEnums");
const ReportingEnums_1 = require("../../__types/__enums/ReportingEnums");
function getUsers(rp, userProjection = {}, metrics) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const withManager = userProjection.custom ? userProjection.custom.includes('manager') : false;
        const userIds = metrics.map(doc => doc.userId);
        const userResults = yield rp.getUsersByIds([{ name: ReportingEnums_1.CommonFilterEnum.ID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: userIds }], withManager);
        const userByIds = keyBy_1.default(userResults.users, '_id');
        const users = userIds.map(id => userByIds[id]);
        return users;
    });
}
exports.getUsers = getUsers;
function setRelatedUsers(rp, relatedUserProjection, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let relatedUserIds = [];
        data.forEach(row => {
            relatedUserIds = uniq_1.default(relatedUserIds.concat(relatedUserProjection.map((doc) => get_1.default(row, doc.getPath)).filter((id) => !!id)));
        });
        const { users } = yield rp.getUsersByIds([
            { name: ReportingEnums_1.CommonFilterEnum.ID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: relatedUserIds }
        ]);
        const usersById = keyBy_1.default(users, 'id');
        data.forEach(row => {
            relatedUserProjection.forEach((doc) => {
                set_1.default(row, doc.setPath, usersById[get_1.default(row, doc.getPath)]);
            });
        });
    });
}
exports.setRelatedUsers = setRelatedUsers;
function getContents(rp, contentProjection = {}, metrics) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const withRootContent = contentProjection.custom ? contentProjection.custom.includes('rootContent') : false;
        const attachContentVersionLog = contentProjection.custom
            ? contentProjection.custom.includes('contentVersionLogs')
            : false;
        const contentIds = uniq_1.default(metrics.map(doc => doc.contentId || doc.questionId)); // questionId incase of stateInteraction
        const contentResults = yield rp.getContentsByIds([{ name: ReportingEnums_1.CommonFilterEnum.ID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: contentIds }], withRootContent, attachContentVersionLog);
        const contentByIds = keyBy_1.default(contentResults.contents, '_id');
        const contents = contentIds.map(id => contentByIds[id]);
        return contents;
    });
}
exports.getContents = getContents;
function setRelatedContents(rp, relatedContentProjection, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let relatedContentIds = [];
        data.forEach(row => {
            relatedContentIds = uniq_1.default(relatedContentIds.concat(relatedContentProjection.map((doc) => get_1.default(row, doc.getPath)).filter((id) => !!id)));
        });
        const { contents } = yield rp.getContentsByIds([
            { name: ReportingEnums_1.CommonFilterEnum.ID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: relatedContentIds }
        ]);
        const contentsById = keyBy_1.default(contents, 'id');
        data.forEach(row => {
            relatedContentProjection.forEach((doc) => {
                set_1.default(row, doc.setPath, contentsById[get_1.default(row, doc.getPath)]);
            });
        });
    });
}
exports.setRelatedContents = setRelatedContents;
function getContentVersionLogs(rp, metrics) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const contentVersionLogIds = metrics.map(doc => doc.contentId_versionId);
        const contentVersionLogResult = yield rp.getContentVersionLogsByIds([
            { name: ReportingEnums_1.CommonFilterEnum.ID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: contentVersionLogIds }
        ]);
        const contentVersionLogs = contentVersionLogResult.contentVersionLogs || [];
        return contentVersionLogs;
    });
}
exports.getContentVersionLogs = getContentVersionLogs;
function setRelatedStates(rp, relatedStateProjection, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let relatedStateIds = [];
        data.forEach(row => {
            relatedStateIds = uniq_1.default(relatedStateIds.concat(relatedStateProjection
                .map((doc) => `${row.userId}_${get_1.default(row, doc.getPath)}`)
                .filter((id) => !!id.split('_')[1])));
        });
        const { states } = yield rp.getStatesByIds([
            { name: ReportingEnums_1.ContentFilterEnum.USERID_CONTENTID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: relatedStateIds }
        ]);
        const statesById = keyBy_1.default(states, 'userId_contentId');
        data.forEach(row => {
            relatedStateProjection.forEach((doc) => {
                set_1.default(row, doc.setPath, statesById[`${row.userId}_${get_1.default(row, doc.getPath)}`]);
            });
        });
    });
}
exports.setRelatedStates = setRelatedStates;
function getGroups(rp, metrics) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const groupIds = uniq_1.default(metrics.map(doc => doc.groupId));
        const groupResults = yield rp.getGroupsByIds([
            { name: ReportingEnums_1.CommonFilterEnum.ID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: groupIds }
        ]);
        const groupByIds = keyBy_1.default(groupResults.groups, '_id');
        const groups = groupIds.map(id => groupByIds[id]);
        return groups;
    });
}
exports.getGroups = getGroups;
function setRelatedGroups(rp, relatedGroupProjection, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let relatedGroupIds = [];
        data.forEach(row => {
            relatedGroupIds = uniq_1.default(relatedGroupIds.concat(flatten_1.default(relatedGroupProjection.map((doc) => get_1.default(row, doc.getPath)))));
        });
        const { groups } = yield rp.getGroupsByIds([
            { name: ReportingEnums_1.CommonFilterEnum.ID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: relatedGroupIds }
        ]);
        const groupsById = keyBy_1.default(groups, 'id');
        data.forEach(row => {
            relatedGroupProjection.forEach((doc) => {
                const groupIds = get_1.default(row, doc.getPath);
                set_1.default(row, doc.setPath, groupIds.map((id) => groupsById[id]));
            });
        });
    });
}
exports.setRelatedGroups = setRelatedGroups;
//# sourceMappingURL=reportHelpers.js.map